<template>
  <div class="pt-1 h-100" :class="!showDeveloperInfo ? 'hide-provider' : 'show-provider'">
    <div
      :id="gaId ? gaId : null"
      class="card card-frame api-card-cta h-100 mr-1 ml-1 cursor-pointer info-card"
      :class="!showDeveloperInfo ? 'hide-provider' : 'show-provider'"
      @click="redirect(to)"
    >
      <div class="card-body d-flex flex-column">
        <h4 class="mt-4">{{ $t(title) }}</h4>
        <p class="text-truncate-4">{{ $t(description) }}</p>
        <div v-if="withDeveloperInfo" class="d-flex align-items-center mt-auto">
          <div class="avatar avatar-md mr-2 border">
            <img v-img="{ type:'small' }" class="avatar-img" width="30" height="30" alt="pro-pic" :src="(userProfile.image_url ? userProfile.image_url : require('@/assets/img/provider-default/default-icon.jpg'))">
          </div>
          <span class="small ml-1">{{ userProfile.developer_name }}</span>
        </div>
      </div>
    </div>
    <b-modal id="hubspotFormModal" ref="hubspotFormModal" class="fade hubspot-form-dialog" centered hide-footer>
      <template slot="modal-header-close">
        <button type="button" class="btn btn-xs btn-icon btn-soft-secondary" data-dismiss="modal" aria-label="Close">
          <img :src="require(`@/assets/svg/icons/icon-68.svg`)">
        </button>
      </template>
      <div class="w-md-90 mx-auto mb-6 form-submit">
        <div id="hubspotForm" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import getEditableInfo from '@/utils/get-editable-info'

export default {
  name: 'InfoBranded',
  components: {
  },
  props: {
    gaId: {
      type: String,
      default: null
    },
    to: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    showDeveloperInfo: {
      type: Boolean,
      default: false
    },
    withDeveloperInfo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loggedIn() {
      return this.$store.getters.login
    },
    userProfile() {
      return this.$store.getters.userProfile
    }
  },
  beforeDestroy() {
    // window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
  },
  mounted() {
    var sheet = window.document.styleSheets[0]
    sheet.insertRule(
      `.info-card {
        background-image: url(${require(`@/assets/svg/components/general-bg-2.svg`)})
      }`,
      sheet.cssRules.length
    )
  },
  methods: {
    redirect(to) {
      if (to.type === 'router') {
        this.$router.push({
          name: to.name,
          params: to.params
        })
      } else if (to.type === 'link') {
        window.open(to.link, '_blank')
      } else if (to.type === 'external-link') {
        console.log(to, to.link_type, to.link_id)
        const url = this.getEditableInfo(to.link_type, to.link_id)
        window.open(url, '_blank')
      } else if (to.type === 'email') {
        window.location.href = `mailto:${to.email_address}`
      } else if (to.type === 'hubspot') {
        this.showFormDialog(to.portalId, to.formId)
      }
    },
    showFormDialog(portalId, formId) {
      const script = document.createElement('script')
      script.src = 'https://js.hsforms.net/forms/v2.js'
      document.body.appendChild(script)
      script.addEventListener('load', () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: portalId,
            formId: formId,
            errorClass: 'hubspotFormError',
            target: '#hubspotForm'
          })
        }
      })
      this.$nextTick(() => {
        this.$refs['hubspotFormModal'].show()
      })
    },
    getEditableInfo(type, id, withLangCode = true) {
      return getEditableInfo(type, id, withLangCode ? this.$i18n.locale.toLowerCase() : '')
    }
  }
}
</script>

<style lang="scss" scoped>
.api-card-cta {
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
}
.cursor-pointer {
  cursor: pointer;
}
.small {
  font-size: 12px;
  line-height: 17px;
  color: #999;
}
.avatar {
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  .avatar-img {
    width: 100%;
    height: 100%;
  }
}
.hubspot-form-dialog {
  padding: 10px !important;
}
</style>
